module.exports = __webpack_public_path__ + "static/media/star-ball_01.5e97b4bb.png";